var cart1 = {};
var order1 = {};
var cartTotal = 0;
order1.input = {};
order1.input.lineItems = [];
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      order1.input.lineItems.splice(this.dataset.index - 1, 1);
    
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

onChange(event) {
    if (event.target.name.includes("Margins") ) {
        var ind = event.target.dataset.index;
        $(`#CartItem-${ind} .loading-overlay`).removeClass("hidden");

        var discountValue = parseFloat(event.target.value) || 0;
        var price = parseFloat($(`#Margins-${ind}`).attr("price")) / 100; 
        var quantity = parseInt($(`#Quantity-${ind}`).val(), 10);
        var selectElement = document.querySelector(`#select-element-${ind}`);
        var discountType = selectElement ? selectElement.value : 'PERCENTAGE';
        
        var discountPercentage;
        if (discountType === 'PERCENTAGE') {
            discountPercentage = discountValue / 100;
        }

        var oldPrice = parseFloat($(`#CartItem-${ind} .pn-total-line-item`).attr("currentitemtotal"));
        if(discountType === 'PERCENTAGE'){
          var newPrice = (price * quantity) - (price * quantity * discountPercentage);
        }else{
          var newPrice = (price * quantity) -( discountValue*quantity);
        }
        $(`#CartItem-${ind} .pn-total-line-item`).text(`₹ ${newPrice.toFixed(2)}`);
        $(`#CartItem-${ind} .loading-overlay`).addClass("hidden");
        
        var total_price = parseFloat(cartTotal) / 100;

        $(`#CartItem-${ind} .pn-total-line-item`).attr("newitemtotal", newPrice.toFixed(2));
        var sum = 0;
        $(`.pn-total-line-item`).each(function () {
            sum += parseFloat($(this).attr("newitemtotal"));
        });
        $(".totals__subtotal-value").text(`₹ ${(sum / 2).toFixed(2)}`);
        $("#partPayAmount").val((sum / 2).toFixed(2));
        
        cartTotal = ((total_price - oldPrice) + newPrice).toFixed(2) * 100;
        $(`#CartItem-${ind} .pn-total-line-item`).attr("currentItemTotal", newPrice.toFixed(2));
      }  
      if (event.target.classList.contains('quantity__input')) {
        const index = event.target.dataset.index;
        const quantity = event.target.value;
        this.updateQuantity(index, quantity, event.target.name);
      }
}

  
  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
      this.enableLoading(line);

   if( document.getElementById(`Quantity-${line}`)!=undefined){
  order1.input.lineItems[line-1].quantity = Number(quantity);
 

   }
    const body = JSON.stringify({
      line: parseInt(line, 10), 
      quantity: parseInt(quantity, 10),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
          if(order1.input.lineItems[line-1]?.appliedDiscount?.valueType){
     var selectElement = document.querySelector(`#select-element-${line}`);
    selectElement.value = order1.input.lineItems[line-1]?.appliedDiscount?.valueType;
             var discountValue = document.querySelector(`#Margins-${line}`);
discountValue.value= order1.input.lineItems[line-1]?.appliedDiscount?.value;
discountValue.style.display = 'block';
     var inputReason = document.getElementById(`Margin-reason-${line}`);
            inputReason.style.display = 'block';
  }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
async function fitmentOrderFunction(){

        if(fitmentInput?.input?.lineItems[0]){
          alert("fit");
           const dialog = document.getElementById('fitmentDialog');
          const fitmentItems = document.getElementById('fitmentItems');
          fitmentInput.input.email = $("#cEmail").val();
          // fitmentItems.innerText = fitmentInput?.input;
          $("#partPayAmount").val();
          $("#hardwareTotal").text($("#partPayAmount").val());
          $("#fullOrderTotal").text(parseInt($("#partPayAmount").val()) + parseInt($("#fitmentTotal").text()));
          
          
          $("#fitmentCustomerName").val($("#fname").val() +" "+$("#lname").val());
          $("#fitmentBike").val($("#make").val() +" "+ $("#model").val());
          dialog.showModal();
          let buttonPressed = new Promise(function(resolve, reject) {
  let theButton = document.getElementById("fitmentDone");
  theButton.addEventListener("click", resolve);
});
         await buttonPressed;
        var fitmentResponse = await fetch("/a/chenInvLvl/createFitmentOrder",{
        method: "POST",
        mode: "no-cors", // no-cors, *cors, same-origin
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fitmentInput),
      });
         
          

     return "all good"

      }else{
          return "all good"
      } 

}
async function customerUpdate(){
  var custInfo =  await fetch(
    `/a/save?email=${$("#cEmail").val()}`,
    {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  var cusCheck = await custInfo.json();
    if($("#cid").val().includes("gid")){
    var customerID = `${$("#cid").val()}`;
  }else{
    var customerID = `gid://shopify/Customer/${$(cid).val()}`;
  }
  // if(customerID !== `gid://shopify/Customer/${cusCheck.id}`){
  //    var customerID = `gid://shopify/Customer/${cusCheck.id}`;
  // }

  var cus = {
    input: {
      id: customerID,
       email: `${$("#cEmail").val()}`,
      firstName: `${$("#fname").val()}`,
      lastName: `${$("#lname").val()}`,
      addresses: [
        {
          firstName: `${$("#fname").val()}`,
      lastName: `${$("#lname").val()}`,
          address1: `${$("#address1").val()}`,
          address2: `${$("#address2").val()}`,
          phone: `${$("#phone").val()}`,
          city: `${$("#city").val()}`,
          province: `${$("#state").val()}`,
          country: "India",
          zip: `${$("#pincode").val()}`,
        },
      ],
    },
  };

   var customerPayload = await fetch(
        `/a/save?id=${$("#cid").val()}&did=${$("#draftId").val()}&email=${$(
          "#cEmail"
        ).val()}`,
        {
          method: "POST",
          mode: "cors", // no-cors, *cors, same-origin
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cus),
        }
      )
     var customerUpdate = await customerPayload.json();
  if(user === "franchise" || user === "hyderabad" || user === "chennai"){
     return "all ok";
  }else{
                if(customerUpdate.data?.customerUpdate?.userErrors[0]){
                return "all ok";
      }else{
                  return "all ok";
      }
        
  }
}

async function draftFunction() {

  order1.input.email = $("#cEmail").val();
  if($("#shipping").val()){
    order1.input.shippingLine={
      "title": "Custom Shipping",
      "price": $("#shipping").val()
    }
  } 
  var draftButton = document.getElementById("draftButton");  
  var checkBox = document.getElementById("order");
  var checkBox1 = document.getElementById("pLater");
   var pOrder= checkBox?.checked || "false";
   var pOrder= checkBox1?.checked || "false";
  var pLater= checkBox1?.checked || "false";
  console.log(pOrder, pLater);
  var email = $("#cEmail").val();
  var phonenumber = $("#phone").val();
  if (user == "store" || user == "dealer" || user == "reseller") {
    var location = "bangalore";
  }else if(user == "chennai store" || user == "chennai"){
    var location = "chennai";
  }
  else if(user == "hyderabad"){
    var location = "hyderabad";
  }else{
    var location = "New Location Please Update";
  }
  
  if (
    $("#ptype").val() == "select" &&
    checkBox1.checked == false &&
    user != "reseller" && user != "franchise"
  ) {
    window.alert("please select payment type");
  } else {
    if ((email != "" && phonenumber != "" && $("#fname").val() != "" && $("#lname").val() != "" && $("#pincode").val() != "" && $("#city").val() != "" && $("#state").val() != "") || user == "reseller" || user == "franchise" || user == "chennai" || user == "hyderabad") {
      draftButton.disabled = true;
      var cval ="Not assigned";
      var itemsWithStatus = [];
      for (i = 0; i < order1.input.lineItems.length; i++) {
        // order1.input.lineItems[i].customAttributes = [];        
        order1.input.lineItems[i].appliedDiscount.value =
          parseInt($(`input[name="Margins-[${i}]"`).val()) || 0;
        order1.input.lineItems[i].appliedDiscount.valueType = 
          document.querySelector(`#select-element-${i + 1}`).value || "PERCENTAGE"          
        if (
          $("#discount-code").val() != "" && $("#discount-code").val() != "select"
        ) {
          order1.input.discountCodes =[$("#discount-code").val()];
        }
          let statusSelect = document.getElementById(`statusSelect-${i + 1}`);
        let getDate = document.getElementById(`deliveryDate-${i + 1}`);
 
          let status = statusSelect ? statusSelect.value : " not assigned";
        var expectedDate = getDate ? getDate.value : " Delivered";
        
        //     order1.input.lineItems[i].customAttributes.push({
        //   key: "status",
        //   value: " " + status,
        // },{
        //   key: "expected date of delivery",
        //   value: " " + expectedDate,
        // });
        }
      order1.input.billingAddress = {
          "address1": `${$("#address1").val()}`,
          "address2": `${$("#address2").val()}`,
          "phone": `${$("#phone").val()}`,
          "city": `${$("#city").val()}`,
          "province": `${$("#state").val()}`,
          "country": "India",
          "zip": `${$("#pincode").val()}`,
        };
      order1.input.shippingAddress = order1.input.billingAddress;
      var customItemTitle = document.getElementsByClassName("customItemTitle");
      if (customItemTitle.length > 0) {
        var customItemSku = document.getElementsByClassName("customItemSku");
        var customItemPrice =
          document.getElementsByClassName("customItemPrice");
        var customItemQuantity =
          document.getElementsByClassName("customItemQuantity");
        var customItemVendor =
          document.getElementsByClassName("customItemVendor");
        for (c = 0; c < customItemTitle.length; c++) {
          order1.input.lineItems.push({
            title: customItemTitle[c].value,
            sku: customItemSku[c].value,
            originalUnitPrice: customItemPrice[c].value,
            taxable:false,
            quantity: parseInt(customItemQuantity[c].value),
          });
        }
      }
      order1.input.customAttributes = [];
      if (user == "reseller" || user == "franchise" || user == "chennai" || user == "hyderabad" ) {
        if(user == "reseller" ){
        order1.input.email = $("#cEmail").val();
        order1.input.customAttributes.push({
          key: "MOP",
          value: "Online Store",
        });
        order1.input.customAttributes.push({
          key: "Sales Person",
          value: "Dealer Online",
        });
             order1.input.customAttributes.push({
          key: "Channel",
          value: user,
        });
        order1.input.tags = ["Dealer", "Gateway", "Online", location+" Store"];
        }else{
          if(location =="chennai" ){
             order1.input.email = "mans@bikenbiker.com";
          }
          else if(location =="hyderabad"){
            order1.input.email = "bikenbiker.hyd@bikenbiker.com";
          }
        order1.input.customAttributes.push({
          key: "MOP",
          value: "pending",
        });
        order1.input.customAttributes.push({
          key: "Sales Person",
          value: customerName,
        });
             order1.input.customAttributes.push({
          key: "Channel",
          value: user,
        });
        order1.input.tags = ["Franchise", location, "Re-stock"];
        }
      } else if (
        $("#ptype").val() != "select" &&
        $("#ptype").val() != "Send Email"
      ) {
        order1.input.customAttributes.push({
          key: "MOP",
          value: $("#ptype").val(),
        });
        order1.input.customAttributes.push({
          key: "Sales Person",
          value: customerName,
        });
         order1.input.customAttributes.push({
          key: "Channel",
          value: user,
        });
        order1.input.tags = [customerName, $("#ptype").val(), location+" Store"];
      } else {
        order1.input.customAttributes.push({
          key: "MOP",
          value: "Gateway",
        });
        order1.input.customAttributes.push({
          key: "Sales Person",
          value: customerName,
        });
        order1.input.customAttributes.push({
          key: "Channel",
          value: "Online",
        });
          order1.input.customAttributes.push({
          key: "Location",
          value: location,
        });
        var itemNotes = [];
        for(var items = 0; items<order1.input.lineItems.length; items++){
        itemNotes.push({sku:cart1.items[items].sku, discount:order1.input.lineItems[items].appliedDiscount.value});
        }
        order1.input.note = JSON.stringify(itemNotes);
        order1.input.tags = [customerName, "Gateway", "Online", location+" Store", "Assisted"];
      }
      if (user != "reseller" && user != "franchise" && user != "chennai" && user != "hyderabad") {
        if (
          checkBox.checked == true &&
          $("#ptype").val() != "Select" &&
          $("#ptype").val() != "Send Email"
        ) {
          pOrder ="true";
        } else if (checkBox1.checked == true) {
          order1.input.paymentTerms = {};
          order1.input.paymentTerms = {
            paymentTermsTemplateId: `gid://shopify/PaymentTermsTemplate/${$("#pPeriod").val()}`,
          };       
          
        } else {
          pOrder ="false";
          if(user == "dealer"){
            order1.input.tags = [customerName, "Dealer", "Gateway", "Online", location+" Store"];
          }
        }
      } else{
        if(user=="reseller"){
        order1.input.tags = ["Dealer", "Gateway", "Online", location+" Store"];
        order1.input.email= customerEmail;
    }else{
        order1.input.tags = [customerName,"Franchise", location, "Re-stock"];
        }
      }
  url = `/a/orders?porder=${pOrder}&plater=${pLater}&did=${$("#draftId").val()}&fname=${$("#cEmail").val()}&semail=${customerEmail}&location=${location}&amount=${$("#partPayAmount").val()}&type=${usertype}`;
      const payload = {
        order1: order1,
        itemsWithStatus: itemsWithStatus,
      };
// var customerResult = customerUpdate();
      customerUpdate();
      var fitmentResult = await fitmentOrderFunction();
      // order1.input.lineItems[i].customAttributes
     
      // order1.input.lineItems.map(items=>{return items.customAttributes});
        var fulfillments = $('.cart-item__status').filter(function(){ 
  return $('select', this).val() !== ""
}).toArray();
      if(fulfillments.length === order1.input.lineItems.length || user != "store"){
        var fulfillmentsResult = "ok";
      }else{
        var fulfillmentsResult = "not ok";
      }
  console.log(fulfillments, fulfillmentsResult);
      if(fitmentResult === "all good" && fulfillmentsResult === "ok"){
      fetch(url, {
        method: "POST",
        mode: "no-cors", // no-cors, *cors, same-origin
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }).then((response) => response.json())
    .then((js) => {
      if(js.name){
      var url1 = "/cart/clear";
      fetch(url1, {
        method: "POST",
        mode: "cors", // no-cors, *cors, same-origin
        headers: {
          "Content-Type": "application/json",
        }
           }).then((response) => response.json());
      sessionStorage.setItem("draftId1",js.name);
      sessionStorage.setItem("cEmail", "");
      sessionStorage.setItem("cid", "");
      sessionStorage.setItem("fname", "");
      sessionStorage.setItem("lname", "");
      sessionStorage.setItem("phone", "");
      sessionStorage.setItem("address1", "");
      sessionStorage.setItem("address2", "");
      sessionStorage.setItem("city", "");
      sessionStorage.setItem("state", "");
      sessionStorage.setItem("pincode", "");
       sessionStorage.setItem("draftId", "");
      $("#draftId").val("")
        localStorage.setItem("make","");
        localStorage.setItem("lastCollection","");
      
      var closeWindow = window.open("/cart/clear");

      setTimeout(function closeTab() {
        closeWindow.close();
      }, 300);
      setTimeout(function closeTab() {
        window.location.href = "/pages/thank-you-for-ordering";
      }, 700);
      }else{
        alert(js[0].message);
          $('#draftButton').prop("disabled", false);
      }
    }).catch(err => {
    console.log(err.data);
    alert(err.data.userErrors.message);
  });
      }else{
        alert(`please update all fulfillment fields`);
        $("#draftButton").removeAttr("disabled");

      }
    } else {
      window.alert("please fill out all customer details");
    }
  }
}
async function clearDetails(){
  $("#cid").val("");
      $("#fname").val("");
      $("#lname").val("");
   $("#phone").val("");
  $("#address1").val("");
      $("#address2").val("");
}
async function dealerDetails() { 
  order1.input.email = $("#cEmail").val();
  if($("#cEmail").val().length>2 && $("#cEmail").val().includes("@")){
    if($("#address1").val().length<5){
     sessionStorage.setItem("cEmail", $("#cEmail").val());
  await fetch(
    `/a/save?email=${$("#cEmail").val()}`,
    {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((json) => {
      $("#cid").val(json.id);
      $("#fname").val(json.first_name);
      $("#lname").val(json.last_name);
      sessionStorage.setItem("cid", json.id);
      sessionStorage.setItem("fname", json.first_name);
      sessionStorage.setItem("lname", json.last_name);
      if (json.phone != null) {
        $("#phone").val(json.phone);
        sessionStorage.setItem("phone", json.phone);
      } else if (json.addresses[0] != null){
        if (json.addresses[0].phone != null){
        $("#phone").val(json.addresses[0].phone);
         sessionStorage.setItem("phone", json.addresses[0].phone);
        }
      }else{
        $("#phone").val("");
        $sessionStorage.setItem("phone", "");
      }
      if (json.addresses[0] != null){
      if (json.addresses[0].address1 != null && json.addresses[0].address1 != "" && json.addresses[0].address1 != undefined) {
      $("#address1").val(json.addresses[0].address1);
      $("#address2").val(json.addresses[0].address2);
sessionStorage.setItem("address1", json.addresses[0].address1);
        sessionStorage.setItem("address2", json.addresses[0].address2);
      }else{
         $("#address1").val(".");
           $("#address2").val(".");
    sessionStorage.setItem("address1", ".");
        sessionStorage.setItem("address2", ".");
      }
      if (json.addresses[0].city != "") {
        $("#city").val(json.addresses[0].city);
        $("#state").val(json.addresses[0].province);
        $("#pincode").val(json.addresses[0].zip);
sessionStorage.setItem("city", json.addresses[0].city);
        sessionStorage.setItem("state", json.addresses[0].province);
        sessionStorage.setItem("pincode", json.addresses[0].zip);
     
      }
      }else{
         $("#city").val("Bangalore");
        $("#state").val("Karnataka");
        $("#pincode").val("560027");
          sessionStorage.setItem("city", "Bangalore");
        sessionStorage.setItem("state", "Karnataka");
        sessionStorage.setItem("pincode", "560027");
      }

                 
    });
  }
  }else{
    sessionStorage.setItem("cEmail", "");
  }
}

if(document
  .getElementById("clearCartButton")){
document
  .getElementById("clearCartButton")
  .addEventListener("click", clearCartAndUpdateUI);
}

// =====================cart update and save============================

async function saveCart() {
   var emailInput = document.getElementById('cEmail');
    if (!emailInput.value) {
      alert('Please an email address.');
      return; 
    }else{
       var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(emailInput.value)) {
          alert('Please enter a valid email address.');
          return;
        }
    }
  const customerDetailsResponse = await fetch(
    `/a/save-cart-item/get-customer-details-bnb?customerEmail=${encodeURIComponent(
      sessionStorage.getItem("cEmail")
    )}`
  );
  const customerDetailsData = await customerDetailsResponse.json();
  if (
    !customerDetailsData.customers ||
    customerDetailsData.customers.length === 0
  ) {
    console.error("Customer details not found.");
    return;
  }

  const customer = customerDetailsData.customers[0];
  const { first_name, last_name, email } = customer;

  var saveCart = await getCart();
  fetch("/a/save-cart-item/saveForSeller-bnb", {
    method: "POST",
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      cartItem: saveCart.items,
      loggedInEmail: customerEmail,
      customerEmail: email,
      customerFname: first_name ? first_name : "",
      customerLname: last_name ? last_name : "",
    }),
  }).then((response) => {
            return response.json();
          })
          .then((data) => {
            window.location.reload();
          })
          .catch((error) => {
            console.error("Error adding item to shopify:", error);
          });

   await clearCartAndUpdateUI(); 

  // console.log("Cart saved successfully");
  return orderItems;
}

async function clearCartAndUpdateUI() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    // console.log("Cart cleared successfully");    
    window.location.reload();
    updateUI();
  } catch (error) {
    console.error("Error clearing cart:", error);
  }
}


function updateUI() {
  updateTable();
  const cartTableBody = document.getElementById("cartTableBody");
  cartTableBody.innerHTML = "";
}

const buttonStyle = `
    position: relative; 
    padding: 5px 5px; 
    background-color: #ffffff; 
    color: #fff; 
    border: 3px solid #ff0000;
    border-radius: 5px; 
    cursor: pointer; 
    width: 100px; 
    height: 30px;
`;

const loaderStyle = `
    position: absolute;
    top: 20%;
    left: 35%;
    transform: translate(-50%, -50%);
    border: 2px solid #000;
    border-radius: 50%;
    border-top: 10px solid transparent; 
    width: 20px;
    height: 20px;
    display: none;
    animation: spin 1s linear infinite; 
`;


// CSS keyframes for the spin animation
const spinKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Append the keyframes to the document head
document.head.insertAdjacentHTML('beforeend', `<style>${spinKeyframes}</style>`);

async function updateTable(selectElement) {
  // Your existing code to fetch data and update the table
  const customerEmail = sessionStorage.getItem("cEmail");
  if(customerEmail){
  fetch(
    `/a/save-cart-item/get-cart-item-bnb?loggedInEmail=${encodeURIComponent(
      customerEmail
    )}`,
    {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((data) => {
      const tableBody = document.getElementById("tableBody");
      tableBody.innerHTML = "";

      var sideWindowContent = document.getElementById('savedCartContent1');    
        sideWindowContent.innerHTML = '';
      data.forEach((customerData) => {
        Object.values(customerData).forEach((customer) => {
          let totalPrice = 0;
          let quantity = 0;
          customer.cartItem.forEach((cartItem) => {
            totalPrice += cartItem.line_price;
            quantity += cartItem.quantity;
          });
          const priceString = totalPrice.toString(); 
          const formattedPrice = "₹ " + priceString.slice(0, -2) + "." + priceString.slice(-2);          
          const newRow = `
            <tr style="border-bottom: 1px solid #ccc;">
              <td style="padding: 10px;">${customer.customerEmail}</td>
              <td style="padding: 10px;">${quantity}</td>
              <td style="padding: 10px;">${formattedPrice}</td>
              <td style="padding: 10px;">
                 <button
                    class="add-to-cart-button"
                    onclick="cleareSaveCart('${customer.customerEmail}')"
                    data-customer-email="${customer.customerEmail}"
                    style="${buttonStyle}"
                    onmouseover="this.focus();"
                    disabled
                >
                    <span class="loader" style="${loaderStyle}"></span>
                    <span class="cart-text" style= "color: black; border: none; border-radius: 5px; cursor: pointer;">Add to Cart</span>
                </button>
                 <button
                  class="shift-button"
                  data-customer-mail="${customer.customerEmail}"
                  id="actionButton"
                  onmouseover="handleMouseOver(this)"
                  onmouseout="handleMouseOut(this)"
                  style="background-color: red; border-radius: 10px; color: black; font-size: 16px;"
                >
                  Shift Item
                </button>

              </td>
            </tr>
          `;
          sideWindowContent.insertAdjacentHTML("beforeend", newRow);
        });
      });

       const button = document.querySelector('.add-to-cart-button');
      const loader = button.querySelector('.loader');
  
      button.addEventListener('click', function(event) {
          if (loader.style.display === 'none') {
              // If loader is hidden, allow the default action 
              return true;
          } else {
              // If loader is displayed, prevent the default action 
              event.preventDefault();
              return false;
          }
      });
      

      // Remove disabled attribute after the table is updated
      document.querySelectorAll(".add-to-cart-button").forEach((button) => {
        button.removeAttribute("disabled");
      });

      let addToCartButtons = document.querySelectorAll(".add-to-cart-button");
      addToCartButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          handleAddToCartButtonClick(button);
        });
      });
       const shiftButtons = document.querySelectorAll(".shift-button");
        shiftButtons.forEach((button) => {
          button.addEventListener("click", function () {
            const mail = this.getAttribute("data-customer-mail");
            const selectedSalesPersonOption =
              selectElement.options[selectElement.selectedIndex];
            if (!selectedSalesPersonOption || selectedSalesPersonOption.textContent === "Select a sales person") {
              alert("Please select a sales person.");
              return;
            }
            const selectedSalesPersonEmail =
              selectedSalesPersonOption.getAttribute("data-email");
            itemMerged(selectedSalesPersonEmail, mail);
          });
        });
    })
    .catch((error) => console.error("Error fetching data:", error));
  }
}

// document.addEventListener("DOMContentLoaded", function() {
//     updateTable();
//     const customerEmail = sessionStorage.getItem("cEmail");
//     updateCustomerForm(customerEmail);
// });

async function cleareSaveCart(cusEmail) {
  const result = await fetch("/a/save-cart-item/clearSavedCart-bnb", {
    method: "POST",
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      loggedInEmail: customerEmail,
      customerEmail: cusEmail,
    }),
  });
  updateTable();
  return orderItems;
}
 function handleMouseOver(button) {
        // Change the background color of the button to white
        button.style.backgroundColor = "white";
        // Change the border color of the button to red
        button.style.borderColor = "red";
    }

    function handleMouseOut(button) {
        // Change the background color of the button back to red when mouse leaves
        button.style.backgroundColor = "red";
        // Change the border color of the button back to none when mouse leaves
        button.style.borderColor = "none";
    }
async function shiftItem(button) {
  try {
    // Your logic for shifting the item

    // Toggle the blinking class on the button
    button.classList.add('blinking');
    setTimeout(() => {
      button.classList.remove('blinking');
    }, 1000); // Remove the blinking class after 1 second (adjust as needed)
  } catch (error) {
    console.error("Error shifting item:", error);
  }
}



async function handleAddToCartButtonClick(button) {
    const loader = button.querySelector('.loader');
    const cartText = button.querySelector('.cart-text');

    loader.style.display = 'inline-block';
    cartText.style.display = 'none';
    button.style.backgroundColor = '#fff';
    button.style.color = '#000'; 
    button.style.width = '60px'; 
    button.style.height = '35px'; 
    button.style.left ='20px';
  
    var cusEmail = button.getAttribute("data-customer-email");

    
    try {
        await updateCustomerForm(cusEmail);
    
        const cartData = await fetchSavedCartData(cusEmail); // Fetch saved cart data
        for (const cartItem of cartData) {
            let formData = {
                items: cartItem,
            };
            const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });
            const data = await response.json();
        }
        
        updateTable(); 
      
        loader.style.display = 'none'; 
        cartText.style.display = 'inline'; 

        window.location.reload();
    } catch (error) {
        console.error("Error:", error);
        // Handle errors here
        loader.style.display = 'none'; 
        cartText.style.display = 'inline'; 
    }
}

async function fetchSavedCartData(cusEmail) {
  return fetch(
    `/a/save-cart-item/get-customer-metafields-bnb?loggedInEmail=${encodeURIComponent(
      customerEmail)}&customerEmail=${encodeURIComponent(cusEmail)}`,
    {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .catch((error) => {
      console.error("There was a problem with your fetch operation:", error);
      throw error; // Rethrow the error to handle it outside this function
    });
}

async function updateCustomerForm(customerEmail) {
  fetch(
    `/a/save-cart-item/get-customer-details-bnb?customerEmail=${encodeURIComponent(
      customerEmail
    )}`
  )
    .then((response) => response.json())
    .then((data) => {
      const customer = data.customers[0];
      if(customer){
        sessionStorage.setItem("cEmail", customer.email || "");
        document.getElementById("cEmail").value = customer.email || "";      
        document.getElementById("fname").value = customer.first_name || "";
        document.getElementById("lname").value = customer.last_name || "";
        document.getElementById("phone").value = customer.phone || "";
        document.getElementById("address1").value =
          customer.default_address.address1 || "";
        document.getElementById("address2").value =
          customer.default_address.address2 || "";
        document.getElementById("city").value =
          customer.default_address.city || "";
        document.getElementById("state").value =
          customer.default_address.province || "";
        document.getElementById("pincode").value =
          customer.default_address.zip || "";

        
        sessionStorage.setItem("fname", customer.first_name || "");
        sessionStorage.setItem("lname", customer.last_name || "");
        sessionStorage.setItem("phone", customer.phone || "");
        sessionStorage.setItem(
          "address1",
          customer.default_address.address1 || ""
        );
        sessionStorage.setItem(
          "address2",
          customer.default_address.address2 || ""
        );
        sessionStorage.setItem("city", customer.default_address.city || "");
        sessionStorage.setItem("state", customer.default_address.province || "");
        sessionStorage.setItem("pincode", customer.default_address.zip || "");
        }
      })
      .catch((error) => console.error("Error fetching customer details:", error));
  }
//=================================================================================

//====================Shift cart to sales person ==================================

async function getSalesPerson() {
  return fetch(
    `/a/save-cart-item/get-sales-person`,
    {
      method: "GET",
      mode: "cors", 
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .catch((error) => {
      console.error("There was a problem with your fetch operation:", error);
    });
}

async function itemMerged(selectedSalesPersonEmail, mail) {  

  if (selectedSalesPersonEmail === customerEmail) {

    return;
  }  
  try {
    const response = await fetch(
      `/a/save-cart-item/merge-cartitem?loggedInEmail=${encodeURIComponent(
      customerEmail)}&salesPersonEmail=${encodeURIComponent(selectedSalesPersonEmail)}&cartItemMail=${encodeURIComponent(mail)}`,
      {
        method: "GET",
        mode: "cors", 
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    
    const data = await response.json();
    window.location.reload();
  } catch (error) {
    console.error("Error merging cart items:", error);
  }
}

document.addEventListener("DOMContentLoaded", async () => {
    try {
        const salesPersons = await getSalesPerson();
        const selectElement = document.createElement("select");
        selectElement.id = "actionSelect";
        selectElement.style.marginRight = "10px";
        selectElement.style.height = "35px";
        selectElement.style.border = "2px solid red";
        selectElement.style.borderRadius = "5px";
        
        const loadingOption = document.createElement("option");
        loadingOption.disabled = true;
        loadingOption.selected = true;
        loadingOption.textContent = "Select a sales person";
        selectElement.appendChild(loadingOption);

        salesPersons.documents.forEach((salesPerson) => {
            const option = document.createElement("option");
            option.value = salesPerson.id;
            option.textContent = `${salesPerson.firstName} ${salesPerson.lastName}`;
            option.setAttribute("data-email", salesPerson.email);
            selectElement.appendChild(option);
        });

        const container = document.getElementById("savedCartContent"); 
        container.insertAdjacentElement("afterbegin", selectElement);        
        updateTable(selectElement);
    } catch (error) {
        console.error("Error fetching salespersons:", error);
    }
});

//===================================================================================

//============================Save customer cart Item=================================
async function customerCartItem(vid,customerEmail) {
  try {
    const variantId =`gid://shopify/ProductVariant/${vid}`
    if (!customerEmail) {
      throw new Error("customerEmail is not defined");
    }
    const response = await fetch("/a/customer-cart/saved-cart-for-customer", {
      method: "POST",
      mode: "cors", // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        variantId: variantId,
        customerEmail: customerEmail,
      }),
    });

    if (response.ok) {
    } else {
      throw new Error(`Failed to save cart, server returned ${response.status} ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error saving cart:", error);
  }
}


async function getCartItemsForCustomer() {
    const customerEmail =  sessionStorage.getItem("cEmail");
    if (!customerEmail) {
        window.alert("Checked through customer Email");
    }  

    try {
        const response = await fetch(
            `/a/customer-cart/get-customer-cart-item?customerEmail=${encodeURIComponent(customerEmail)}`,
            {
                method: "GET",
                mode: "cors", 
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }    

        const data = await response.json();
        return data; // Return the cart items
    } catch (error) {
        console.error("cart items:", error);
        return []; // Return an empty array if there's an error
    }
}


//=========================================================================

async function getCart() {
  const result = await fetch("/cart.json");  
  if (result.status === 200) {
      const cartData = await result.json();
      return cartData;
  }
  throw new Error(
    `Failed to get request, Shopify returned ${result.status} ${result.statusText}`
  );
}

$(window).on("load", async function () {
  
  $("#make").val(localStorage.getItem("make"));
  $("#model").val(localStorage.getItem("lastCollection"));
  $("#draftId").val(sessionStorage.getItem("draftId"));
  if(sessionStorage.getItem("draftId")!=null || sessionStorage.getItem("draftId")!=undefined){
  if(sessionStorage.getItem("draftId").includes("gid")){
    $("#draftButton").html("Update Order");
  }
  }else{
    $("#draftId").html("Not defined");
    $("#draftId").val("Not defined");
  }
  cart1 = await getCart();
  cartTotal = cart1.total_price;
  if(sessionStorage.getItem("cEmail") !== null || sessionStorage.getItem("cEmail") !== ""){
    $("#cEmail").val(sessionStorage.getItem("cEmail"));
    $("#cEmail").focus();
    $("#cid").focus();
     $("#cid").val(sessionStorage.getItem("cid"));
     $("#fname").val(sessionStorage.getItem("fname"));
     $("#lname").val(sessionStorage.getItem("lname"));
     $("#phone").val(sessionStorage.getItem("phone"));
     $("#address1").val(sessionStorage.getItem("address1"));
    $("#address2").val(sessionStorage.getItem("address2"));
     $("#city").val(sessionStorage.getItem("city"));
    $("#state").val(sessionStorage.getItem("state"));
     $("#pincode").val(sessionStorage.getItem("pincode"));

    $("#sfldata").html(" ");
  } else{
    $("#cEmail").val("");
     $("#cid").val("");
     $("#fname").val("");
     $("#lname").val("");
     $("#phone").val("");
     $("#address1").val("");
    $("#address2").val("");
     $("#city").val("");
    $("#state").val("");
     $("#pincode").val("");
    sessionStorage.setItem("cEmail", "");
    sessionStorage.setItem("cid", "");
    sessionStorage.setItem("fname", "");
    sessionStorage.setItem("lname", "");
    sessionStorage.setItem("phone", "");
    sessionStorage.setItem("address1", "");
    sessionStorage.setItem("address2", "");
    sessionStorage.setItem("city", "");
    sessionStorage.setItem("state", "");
     sessionStorage.setItem("pincode", "");
    
  }
  var vendors = {};
  for (i = 0; i < cart1.items.length; i++) {
    var vendor = cart1.items[i].vendor;
    
    if (cart1.items[i].discounts.length != 0 && typeof user !== 'undefined') {
 
    if (cart1.items[i].discounts[0].valueType === "FIXED_AMOUNT") {
        var discountValue = cart1.items[i].discounts[0].amount;
    } else {
        var discountValue = (cart1.items[i].discounts[0].amount * 100) / cart1.items[i].price;
    }

    $(`input[name="Margins-[${i}]"`).val(discountValue);
      order1.input.lineItems.push({
        "variantId": `gid://shopify/ProductVariant/${cart1.items[i].id}`,
        "quantity": cart1.items[i].quantity,
        "title": cart1.items[i].title,
        "sku": cart1.items[i].sku,
        "appliedDiscount": {
            "description": cart1.items[i].discounts[0].title,
            "value": discountValue || 0, 
            "valueType": cart1.items[i].discounts[0].valueType || "PERCENTAGE",
            "title": user,
        },
      });
    } else if (typeof user !== 'undefined'){
      order1.input.lineItems.push({
        "variantId": `gid://shopify/ProductVariant/${cart1.items[i].id}`,
        "quantity": cart1.items[i].quantity,
        "title": cart1.items[i].title,
        "sku": cart1.items[i].sku,
        "appliedDiscount": {
          "description": "wholesale",
          "value": 0,
          "valueType": "PERCENTAGE",
          "title": user,
        },
      });
    }else{
            order1.input.lineItems.push({
        "variantId": `gid://shopify/ProductVariant/${cart1.items[i].id}`,
        "quantity": cart1.items[i].quantity,
        "appliedDiscount": {
          "description": "wholesale",
          "value": 0,
          "valueType": "PERCENTAGE",
          "title": "none",
        },
      });
    }

    if (vendors.hasOwnProperty(vendor) == true) {
      vendors[vendor].quantity =
        vendors[vendor].quantity + cart1.items[i].quantity;
      vendors[vendor].price = vendors[vendor].price + cart1.items[i].line_price;
    } else {
      vendors[vendor] = {
        "quantity": cart1.items[i].quantity,
        "price": cart1.items[i].line_price,
      };
    }
  }
  for (v in vendors) {
    var collection = `"{{collections[${v}].metafields.dealer.margins}}"`;
  }
  if (typeof user !== 'undefined'){
  if (user == "dealer" || user == "reseller" || user == "franchise" ) {
    fetch("https://www.bikenbiker.com/apps/gat", {
      method: "POST",
      mode: "cors", // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(vendors),
    })
      .then((response) => response.json())
      .then((json) => {

        for (const key in json) {
          if (json.hasOwnProperty(key)) {
            $(`input[vendor="${key}"]`).val(json[key].per);
          }
        }
      });
  }
  if (user == "store") {
    $("#city").val("Bangalore");
    $("#state").val("Karnataka");
  }
  }
});

// --- Replace your mail() function with this one ---

function mail(element) {
  // 1. Get the data from the element's data attributes
  const email = element.dataset.email;
  const addressString = element.dataset.address;
  const firstName = element.dataset.firstname;
  const lastName = element.dataset.lastname;

  // Set the email value in the form
  document.getElementById("cEmail").value = email;

  // 2. Parse the address string (this will now work correctly)
  const address = JSON.parse(addressString);

  // 3. Check if a valid address object was provided
  if (address && address.address1) {
    console.log("Filling form from clicked suggestion...");
    $("#fname").val(firstName || address.firstName || address.first_name || "");
    $("#lname").val(lastName || address.lastName || address.last_name || "");
    $("#phone").val(address.phone || "");
    $("#address1").val(address.address1 || "");
    $("#address2").val(address.address2 || "");
    $("#city").val(address.city || "");
    $("#state").val(address.province || "");
    $("#pincode").val(address.zip || "");
  } else {
    // Fallback to dealerDetails if the suggestion had no address
    console.log("Suggestion had no address. Calling dealerDetails() as a fallback...");
    dealerDetails();
  }

  // Hide the search results modal
  document.getElementById("result").innerHTML = "";
  document.getElementById("srcModal").style.display = "none";
}
function updateAddress(address1, city, state){

     $("#address1").val(address1.split(',').slice(0, -5));
    $("#address2").val(address1.split(',')[address1.split(',').length-5]);
     $("#city").val(city);
      $("#state").val(state);
    document.getElementById("result").innerHTML = "";
  document.getElementById("srcModal").style.display = "none";
}
function addCustomItem() {
  var table = document.getElementById("cartItems");
  if (table == null) {
    // console.log("cartItems does not exist");
  }
  var row = table.insertRow();
  var cell1 = row.insertCell(0);
  var cell2 = row.insertCell(1);
  var cell3 = row.insertCell(2);
  var cell4 = row.insertCell(3);
  var cell5 = row.insertCell(4);
  var cell6 = row.insertCell(5);

  cell1.innerHTML =
    "<label class='Title'>Title</label><br><input class='customItemTitle' type='textbox'>";
  cell2.innerHTML =
    "<label class='Sku'>Sku</label><br><input class='customItemSku' type='textbox'>";
  cell3.innerHTML = "";
  cell4.innerHTML =
    "<label class='Quantity'>Quantity</label><br><input class='customItemQuantity' type='textbox'>";
  cell5.innerHTML =
    "<label class='Vendor'>Vendor</label><br><input class='customItemVendor' type='textbox'>";
  cell6.innerHTML =
    "<label class='Price'>Price</label><br><input type='number' class='customItemPrice' type='textbox'>";
}



window.onclick = function (event) {
  var srcModal = document.getElementById("srcModal");
  if (event.target == srcModal) {
    srcModal.style.display = "none";
    document.getElementById("result").innerHTML = "";
  }
};

$("#srcModal").click(function(){
  $("#srcModal").css("display","none")

}); 



